module.exports = __webpack_public_path__ + "img/image003.4327179d.png";